import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

const ReferencePickerTopBar: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Flex
    justifyContent="space-between"
    alignItems="center"
    padding="12px 16px"
    borderBottom={`1px solid ${theme.colors.charcoal200}`}
  >
    {children}
  </Flex>
);

export default ReferencePickerTopBar;
